'use client';

import { MenuEntryCGType } from '@/types/graphql/root';

export default function PoiDetailMenus({ menus }: { menus: MenuEntryCGType[] }) {
  if (menus.length === 0) return null;

  return (
    <>
      <div id='poi-detail-menus'>
        <p className='text-gray-800 px-20pxr pt-24pxr heading-16-b'>메뉴</p>
        <div className='flex flex-col px-20pxr pt-20pxr pb-32pxr gap-16pxr'>
          {menus.map((menu, index) => (
            <div
              key={'menuItem_' + index}
              className='flex flex-row items-center justify-between text-gray-700 body-14-r'
            >
              <span>{menu.name}</span>
              <span>{menu.price}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='w-full bg-gray-100 h-12pxr'></div>
    </>
  );
}
